<template>
  <v-text-field outlined dense :height="height" ref="input" :type="type" :append-outer-icon="appendIcon" @blur="roundValue" :prepend-inner-icon="prependIcon" :hideDetails="true" v-model="text" :rules="rules" :maxlength="maxLength" :minLength="minLength" :readonly="readonly" :filled="filled" :placeholder="placeholder">
    <template v-slot:append v-if="appendText">{{appendText}}</template>
  </v-text-field>
</template>

<script>
  import DataFormatter from '@/mixins/DataFormatter';
  export default {
    name: 'ResTextField',
    mixins: [DataFormatter],
    props: {
      value: {
        required: true
      },
      maxLength: {
        type: Number,
        default: 100
      },
      minLength: {
        type: Number,
        default: 0
      },
      rules: {
        type: Array,
        default: () => []
      },
      height: {
        type: Number,
        default: 30
      },
      readonly: {
        type: Boolean,
        default: false
      },
      appendIcon: {
        type: String,
        default: ''
      },
      prependIcon: {
        type: String,
        default: ''
      },
      appendText: {
        type: String,
        default: ''
      },
      filled: {},
      placeholder: {},
      round: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: 'text'
      }
    },
    computed: {
      text: {
        get () {
          return this.value
        },
        set(newValue) {
          this.$emit("input", newValue)
        }
      },
    },
    methods: {
      roundValue() {
        if (this.round) {
          var val = this.text;
          val = this.formatCurrency(val, false);
          setTimeout(() => {
            this.$refs.input.internalValue = val;
          })
        }
      },
      validate() {
        return this.$refs.input.validate();
      }
    }
  }
</script>

<style scoped lang="scss">
  .v-text-field--outlined.v-input--is-focused::v-deep fieldset {
      border-color: var(--v-resBlue-darken1) !important;
  }

  .v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)::v-deep fieldset {
      border-color: var(--v-resGrey-darken1) !important;
  }

  .v-text-field::v-deep input[type=number]::-webkit-inner-spin-button,
  .v-text-field::v-deep input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
</style>
